import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../hooks/use-stores';
import { useTranslation } from 'react-i18next';
import { VideoPlayer } from '@awarego-ui/components';
import ThemedSpinner from '../components/themed/ThemedSpinner';

export default observer(
    ({
        subject,
        logEvent,
        onChange,
        enableAssessmentFinish,
        onLastDecision,
        resetDecisions,
        videoTokenStore,
    }) => {
        const { store, brandingStore } = useStores();
        const { t } = useTranslation();

        const { videoPlayerUrl } = store;
        const { tokens, tokenIndex, language } = videoTokenStore;
        const [activeVideoId, setActiveVideoId] = useState(
            subject && (subject.id || subject.subject_id)
        );

        const videoTokenRequested = async (predefinedSubjectId) => {
            const subjectId =
                predefinedSubjectId || subject.id || subject.subject_id;
            await videoTokenStore.videoToken(subjectId, language);
            const key = videoTokenStore.getTokenKey(subjectId, language);
            if (videoTokenStore.tokenIndex[key]) {
                setActiveVideoId(subjectId);
            }
        };

        useEffect(() => {
            setActiveVideoId(subject && (subject.id || subject.subject_id));
        }, [subject]);

        useEffect(() => {
            const loadVideoData = async () => {
                const defaultSubjectId = subject.id || subject.subject_id;
                const subjectId = activeVideoId || defaultSubjectId;
                await store.loadVideoPlayerUrl(defaultSubjectId, language);
                const key = videoTokenStore.getTokenKey(subjectId, language);
                if (subject && subjectId && !tokenIndex[key]) {
                    await videoTokenStore.videoToken(subjectId, language);
                }
            };

            loadVideoData();
        }, [subject, tokens, tokenIndex, language, activeVideoId]);

        const token =
            tokenIndex[
                videoTokenStore.getTokenKey(
                    activeVideoId || subject.id,
                    language
                )
            ];

        return store.loadingVideoUrl ? (
            <ThemedSpinner />
        ) : (
            token && (
                <VideoPlayer
                    videoTokenRequested={videoTokenRequested}
                    token={token && token.token}
                    videoPlayerUrl={videoPlayerUrl}
                    t={t}
                    subject={subject}
                    logEvent={logEvent}
                    onChange={onChange}
                    enableAssessmentFinish={enableAssessmentFinish}
                    presetCaptionsLanguage={store.playerPresetCaptionsLanguage}
                    captionsSettings={store.playerCaptionsSettings}
                    canFastForward={brandingStore.canFastForward}
                    onLastDecision={onLastDecision}
                    resetDecisions={() => {
                        resetDecisions();
                        subject.resetDecisions();
                    }}
                    onFinishedWatchingAnswer={() => {
                        subject.hasSeenAnswer();
                    }}
                />
            )
        );
    }
);
